import React from 'react';
import './HeroProjectManager.css';
import HeroProjectImage from './HeroProjectImage';
import HeroProjectText from './HeroProjectText';
import Carousel from './Carousel';
import { Link } from 'react-router-dom';
import { base_url, hero_images, hero_text } from './Constants.js';


const HeroProjectManager = () => {

    const textstyle = {
        color: "white",
        backgroundColor: "black",

    };




    return (
        <div className="project-link">

            <div className="project-container">
                <Carousel>

                    {hero_images.map((hero_images, index) => (
                        <Link to={hero_images.projectUrl} state={hero_images.project}>
                            <HeroProjectImage
                                key={hero_images.id}
                                image={hero_images.image}
                                project={hero_images.project}
                            />
                        </Link>
                    ))}
                </Carousel>

                <Carousel>

                    {hero_text.map((hero_text, index) => (
                        <Link to={`/project/${hero_text.projectPath}`} state={hero_text.project} style={{ textDecoration: 'none' }}>
                            <div className="carousel-container">
                                <HeroProjectText
                                    key={hero_text.id}
                                    subject={hero_text.subject}
                                    title={hero_text.title}
                                    description={hero_text.description}
                                    backgroundcolor={hero_text.backgroundcolor}
                                    fontstyle={textstyle}
                                    project={hero_text.project}
                                />
                            </div>
                        </Link>
                    ))}
                </Carousel>

            </div>
        </div>
    );
};

export default HeroProjectManager;